import { useState } from 'react'
import { Image } from 'antd'
import Link from 'next/link'
import useTranslation from '@/hooks/useTranslation'

import PDFView from './modals/PDFView'

const imageTypes = ['png', 'jpeg', 'jpg', 'tiff', 'svg']
const txtTypes = ['pdf']

const FileTab = ({ fileLink, index }) => {
  const { t } = useTranslation()

  const [pdfOpen, setPdfOpen] = useState(false)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <Link
        href={fileLink}
        target='_blank'
        rel='noreferrer'
        className='bg-blue_100 text-blue text-sm font-medium text-center border border-blue_300 underline p-8 ltr:mr-8 rtl:ml-8 inline-block w-[11.25rem]'
        onClick={(event) => {
          event.preventDefault()
          const fileType = fileLink.split('.').slice(-1)[0]

          if (txtTypes.includes(fileType)) {
            setPdfOpen(true)
          } else if (imageTypes.includes(fileType)) {
            setVisible(true)
          } else {
            window.open(fileLink, '_blank')
          }
        }}
      >
        {t('Document')} {index + 1}
      </Link>
      <PDFView open={pdfOpen} setOpen={setPdfOpen} link={fileLink} />

      <Image
        className='image-link'
        width={0}
        style={{ display: 'none' }}
        src={fileLink}
        alt={fileLink}
        preview={{
          visible,
          onVisibleChange: (value) => {
            setVisible(value)
          },
        }}
      />
    </>
  )
}

export default FileTab
